import Vue from 'vue'

Vue.filter('cleanTitle', (title: string | null, cutoff: 9999): string => {
  if (!title) return ''
  title = title.replace(/([a-zA-Z0-9])\/([a-zA-Z0-9])/g, '$1 / $2').replace(/([a-zA-Z0-9]),([a-zA-Z0-9])/g, '$1, $2')
  return title.slice(0, cutoff) + (title.length > cutoff ? '...' : '')
})
